<script lang="ts" setup>
import { usePaneStore } from '#layers/workspace/stores/pane';
import { RenderPageHeaderActions } from './page-slot-provider';
import WorkspaceChromeHeaderPanelToggles from './WorkspaceChromeHeaderPanelToggles.vue';
import WorkspaceChromeHeaderSeparator from './WorkspaceChromeHeaderSeparator.vue';
import WorkspaceChromeSidebarToggle from './WorkspaceChromeSidebarToggle.vue';
import WorkspaceSwitcher from './WorkspaceSwitcher.vue';

const paneStore = usePaneStore();
</script>

<template>
	<header
		class="
			@container flex w-full items-center justify-between px-page ps-2.5 transition-[padding]
			block-(--primary-header-height)
		"
		:class="{
			'ps-2 sm:ps-3': paneStore.sidebarSplitPanelCollapsed,
			'relative before:absolute before:inset-s-0 before:border-s before:border-accented before:block-5': !paneStore.sidebarSplitPanelCollapsed,
		}"
	>
		<div class="flex min-w-0 flex-1 items-center overflow-hidden">
			<WorkspaceChromeSidebarToggle v-if="paneStore.sidebarSplitPanelCollapsed" />

			<template v-if="paneStore.sidebarSplitPanelCollapsed">
				<WorkspaceSwitcher />
				<WorkspaceChromeHeaderSeparator />
			</template>

			<slot />

			<div class="flex flex-1 items-center gap-2 overflow-hidden">
				<RenderPageHeaderActions />
			</div>
		</div>

		<WorkspaceChromeHeaderPanelToggles />
	</header>
</template>
